module.exports = __webpack_public_path__ + "static/media/purple-tile.b5faee50.png";